import { makeAjax, url, respStatus } from '../../helpers/global_helper';

const redirectArr = [
    "/login-pin",
    "/security-question",
    "/security-validation",
    "/reminder-password",
    '/change-password',
];

const NavigationCheck = async (props, source) => {
    const { location, navigate } = props;
    try {
        const response = await makeAjax(url.USER_API.checkIfPinAlreadySet, [], url.USER_MS_EXT);
        const resp = response.data;

        if (response.status !== respStatus["SUCCESS"]) {
            if (source == 'main')
                props?.setEnablePage("Y");
            return;
        }

        if (resp) {
            const config_status = resp.get_tenant_config?.value;
            if (
                config_status === true &&
                resp.enabled_active_pin === true &&
                resp.active_pin === false &&
                !redirectArr.includes(location?.pathname)
            ) {
                navigate("/login-pin");
                if (source == 'main')
                    props?.setEnablePage("Y");
                return;
            } else if (
                config_status === true &&
                resp.enabled_active_pin === true &&
                resp.is_pin_verified === false &&
                !redirectArr.includes(location?.pathname)
            ) {
                navigate("/security-validation");
                if (source == 'main')
                    props?.setEnablePage("Y");
                return;
            } else if (
                (resp.is_security_question_set === false ||
                    resp.is_security_question_set === null) &&
                !redirectArr.includes(location?.pathname)
            ) {
                navigate("/security-question");
                if (source == 'main')
                    props?.setEnablePage("Y");
                return;
            } else if (
                resp.is_password_active === false &&
                !redirectArr.includes(location?.pathname)
            ) {
                navigate("/reminder-password");
                if (source == 'main')
                    props?.setEnablePage("Y");
                return;
            } else if (resp?.admin_reset && resp.is_pin_verified === true) {
                navigate("/change-password");
                return;
            }
            if (source == 'main')
                props?.setEnablePage("Y");
        } else if (redirectArr.includes(location?.pathname)) {
            navigate("/");
            if (source == 'main')
                props?.setEnablePage("Y");
            return;
        }

        if (source == 'main') {
            props?.setEnablePage("Y");
            props?.setMobileHeaderType('after');
        }
    } catch (ex) {
        if (redirectArr.includes(location?.pathname)) {
            navigate("/");
            if (source == 'main')
                props?.setEnablePage("Y");
            return;
        }
        if (source == 'main')
            props?.setEnablePage("Y");
    }
};

export default NavigationCheck;
